// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeAccountContactModel {
    static getAttributeTypeMap() {
        return SimpleIntakeAccountContactModel.attributeTypeMap;
    }
}
SimpleIntakeAccountContactModel.discriminator = undefined;
SimpleIntakeAccountContactModel.additionalProperties = false;
SimpleIntakeAccountContactModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "phones",
        "baseName": "phones",
        "type": "SimpleIntakeAccountContactPhonesModel"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "RoleType"
    },
];
//# sourceMappingURL=simpleIntakeAccountContactModel.js.map